import i18n from '@/plugins/vue-i18n.js';
import axios from '@/plugins/axios.js';
import wait from '@/plugins/vue-wait.js';
import { formatFullName } from '@/utils/index.js';

export default {
    async fetchConversations({ commit, state, rootState }, payload = {}) {
        const search = payload.search || '';
        const active = search ? true : state.showActiveConversation;
        const intelligentFilterEnabled = state.intelligentFilterEnabled;
        const conversationId = payload.conversationId || state.selectedConversationId || null;

        wait.start('fetching.conversations');

        const response = await axios.get('conversations', {
            params: {
                search,
                conversationId,
                active,
                intelligentFilterEnabled,
                perPage: 25,
                page: state.conversationsPage,
                selectedContactId: state.selectedContactId,
                userRelatedId: state.userRelatedId,
                selectedUserId: state.selectedUserId,
                account_id: rootState.authUser.account.id,
            },
        });

        commit('setConversationsTotal', response.data.meta.total);
        commit('addConversations', response.data.data);

        if (response.data.data.length) {
            commit('incrementConversationsPage');
        }

        wait.end('fetching.conversations');

        return response.data.data;
    },

    setSelectedConversation({ commit, state }, conversationId) {
        if (empty(conversationId)) {
            commit('setPageTitle', i18n.t('chat.pageTitle'), { root: true });
            commit('removeSelectedConversation');
            return;
        }

        commit('setSelectedConversationId', conversationId);

        const tmpSelectedConversation = state.conversations.find(value => value.id == conversationId);

        if (!empty(tmpSelectedConversation)) {
            commit('setPageTitle', formatFullName(tmpSelectedConversation.contact_phone.contact), { root: true });
        }
    },

    getSelectedConversationFromRelated({ state }, payload) {
        if (empty(payload.selectedContactId)) {
            return null;
        }

        const conversation = state.conversations.find(tmpConversation => {
            if (!empty(payload.userRelatedId)) {
                const user = tmpConversation.users.filter(tmpUser => tmpUser.related_id == payload.userRelatedId);

                if (empty(user)) {
                    return false;
                }
            }

            return tmpConversation.contact_phone.contact_id == payload.selectedContactId;
        });

        if (!conversation) {
            return null;
        }

        return conversation;
    },

    async changeSelectedConversationActivation({ commit, state }, activate) {
        commit('changeSelectedConversationActivation', activate);

        // Change the activation
        await axios.put(`conversations/${state.selectedConversationId}`, {
            active: activate,
        });
    },

    async changeSelectedConversationProviderPhone({ commit, state }) {
        // Change the activation
        const conversation = await axios.put(`conversations/new-provider-phone/${state.selectedConversationId}`);
        commit('changeSelectedConversationProviderPhone', conversation.data.data);
    },

    async changeSelectedConversationContactPhone({ commit, state }, phoneId) {
        // Change the activation
        const conversation = await axios.put(`conversations/${state.selectedConversationId}`, {
            contact_phone_id: phoneId,
        });

        commit('changeSelectedConversationContactPhone', conversation.data.data);
    },

    async fetchTemplateCategories({ commit, rootState }) {
        wait.start('fetching.templateCategories');

        const response = await axios.get('categories', {
            params: {
                account_id: rootState.authUser.account.id,
            },
        });

        // Make sure account is still the selected one.
        if (response.config.params.account_id == rootState.authUser.account.id) {
            commit('setTemplateCategories', response.data.data);
        }

        wait.end('fetching.templateCategories');
    },

    async deleteTemplateCategory({}, category) {  // eslint-disable-line
        await axios.delete(`categories/${category.id}`);
    },

    async deleteTemplate({}, template) {  // eslint-disable-line
        await axios.delete(`templates/${template.id}`);
    },

    setIntelligentFilterEnabled({ commit }, isEnabled) {
        commit('setIntelligentFilterEnabled', isEnabled);

        localStorage.setItem('intelligentFilterEnabled', isEnabled);
    },
};
